import React from "react";

function BS4_CustomForms() {
  return (
    <div>
      <h1>BS4_CustomForms Component</h1>
      <p>This is the BS4_CustomForms tutorial page content.</p>
    </div>
  );
}

export default BS4_CustomForms;
